import { alertController } from '@ionic/core'

export function deleteAlert(Header, msg, Handler) {
    alertController.create({
        header: Header,
        message: msg,
        buttons: [{
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'cancel-text',
            handler: () => {
                console.log('Confirm Cancel');
            }
        },
        {
            text: 'Delete',
            role: 'delete',
            color: 'danger',
            cssClass: 'red',
            handler: Handler
        }
        ]
    }).then((alert) => alert.present());
}

export function updateArray(array, index, item) {
    if (index === -1) {
        return array
    }
    return [
        ...array.slice(0, index),
        item,
        ...array.slice(index + 1)
    ];
}
